import { gql } from "@apollo/client";

const UNSKIP_TOPIC = gql`
  mutation UnskipTopic($id: ID!) {
    unskipTopic(input: { id: $id }) {
      topic {
        id
      }
    }
  }
`;

export default UNSKIP_TOPIC;
